import { connect } from 'react-redux';
import HubspotView from './HubspotView.jsx';
import { fetchIntegrations, fetchHubspotIntegration } from "src/legacy/redux/actions/integrations.jsx";
import { authenticateAccount, overrideAccount, overridePrimaryInstance, fetchTotalHubspotIntegrations} from 'src/legacy/redux/actions/integrations/hubspot.jsx';
import {trackAdoptionMetricsForPluginConnectedEvent} from "src/legacy/redux/actions/adoption";
import _ from 'lodash';
import withUseHooks from 'src/legacy/components/withUseHooks.jsx';

const mapStateToProps = (state, ownProps) => {
  return {
    integration: _.get(state.legacyRootReducer.settings, "integrations.hubspot.integration", ""),
    primaryIntegration: _.get(state.legacyRootReducer.settings, "integrations.hubspot.integration.primaryIntegration"),
    secondaryInstance: _.get(state.legacyRootReducer.settings, "integrations.hubspot.integration.configuration"),
    integrations: state.legacyRootReducer.settings.integrations,
    deactivating: _.get(state.legacyRootReducer.settings.integrations, "activated.deactivating.loading"),
    user: state.users.me,
    activeIntegrations: _.get(state.legacyRootReducer.settings, "integrations.activated.items"),
    totalHubspotIntegrations: _.get(state, "legacyRootReducer.settings.integrations.hubspot.totalHubspotIntegrations", 0),
    authenticating: _.get(state, "legacyRootReducer.settings.integrations.hubspot.authentication.authenticating"),
    saving: _.get(state, "legacyRootReducer.settings.integrations.hubspot.changes.saving")
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    authenticateAccount: (code) => {
      return dispatch(authenticateAccount(code));
    },

    fetchIntegrations: () => {
      return dispatch(fetchIntegrations());
    },

    fetchHubspotIntegration: () => {
      return dispatch(fetchHubspotIntegration());
    },
     
    overrideAccount: (id, code) => {
      return dispatch(overrideAccount(id, code));
    },
    
    overridePrimaryInstance: (id, code) => {
      return dispatch(overridePrimaryInstance(id, code));
    },

    fetchTotalHubspotIntegrations: () => {
      return dispatch (fetchTotalHubspotIntegrations());
    },

    trackAdoptionMetricsForPluginConnectedEvent: (partnerName) => {
      return dispatch(trackAdoptionMetricsForPluginConnectedEvent(partnerName))
    }
  }
}

const HubspotPage = connect (
    mapStateToProps,
    mapDispatchToProps
)(HubspotView);

export default withUseHooks(HubspotPage);